import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../constants/constants';
export const componentKey = "NOTICE_SECTION";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setGridData: (state, action) => {
            state.gridData = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setSkip: (state, action) => {
            state.skip = action.payload;
        },
        setTotalData: (state, action) => {
            state.totalData = action.payload;
        },
        setActions: (state, action) => {
            state.selectedNotice = action.payload;
        },
        setFilterText: (state, action) => {
            state.filterText = action.payload;
        },
        setPayersList: (state, action) => {
            state.payersList = action.payload;
        },
        setNoticeList: (state, action) => {
            state.noticeList = action.payload;
        },
        setAssigneeList: (state, action) => {
            state.assigneeList = action.payload;
        },
        setShowAddNoticePopup: (state, action) => {
            state.showAddNoticePopup = action.payload;
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        gridData: [],
        actions: [],
        rowsPerPage: 10,
        skip: 0,
        totalData: 0,
        filterText: '',
        payersList: [],
        noticeList: [],
        assigneeList: [],
        showAddNoticePopup: false,
    }
});
export const { setLoadingState, setActions, setShowAddNoticePopup, setRowsPerPage, setSkip, setGridData, setTotalData, setFilterText, setPayersList, setNoticeList, setAssigneeList } = actions;
